export default __webpack_public_path__ + "static/media/signature.2a1177eb.png";